<template>
  <div class="main-page column-me">
    <!--页面头部-->
    <Header></Header>
    <div id="content" class="column-me flex1" style="overflow: auto;">
      <!-- 页面主内容 -->
      <div class="flex1" style="background: #FFFFFF;">
        <!-- vue3.0配置 -->
        <router-view v-slot="{ Component }">
          <keep-alive>
            <component :is="Component" v-if="$route.meta.keepAlive" :key="$route.path"/>
          </keep-alive>
          <component :is="Component" v-if="!$route.meta.keepAlive"/>
        </router-view>
      </div>
      <!--页面底部-->
      <Footer></Footer>
      <!-- 回到顶部 -->
      <el-backtop target="#content">
        <div class="scroll-top-div" @mouseenter="mouseenter" @mouseleave="mouseleave">
          <img :src="imgTop" draggable="false" class="img-top">
        </div>
      </el-backtop>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header.vue';
import Footer from '@/components/footer.vue';

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      imgTop: require('../assets/img/btn_Topping.png'),
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to.name != from.name) {
          document.getElementById('content').scrollTop = 0
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  mounted() {

  },
  methods: {
    mouseenter() {
      this.imgTop = require('../assets/img/btn_Topping_s.png')
    },
    mouseleave() {
      this.imgTop = require('../assets/img/btn_Topping.png')
    },
  }
}
</script>

<style lang="scss" scoped>
.main-page {
  height: 100vh;
  font-size: 18px;
  color: #454F5E;
  background: #FFFFFF;
  font-family: font-n, sans-serif;

  &:deep(.el-backtop) {
    width: auto;
    height: auto;
    background: none;
    box-shadow: none;
  }

  .scroll-top-div {
    width: 80px;
    height: 80px;
    background: none;

    .img-top {
      width: 100%;
      height: 100%;
      object-fit: scale-down;
    }
  }
}
</style>
